import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "underlineForm" }
const _hoisted_13 = { class: "dialog-footer" }
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_MiniBusinessList = _resolveComponent("MiniBusinessList")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "业务编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessNo,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.businessNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "业务名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.businessName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.businessName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "外包商", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.outsourceCompany,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.outsourceCompany) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "业务代表", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.salesManId,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.salesManId) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onFocus: _ctx.handleSalesManFocus,
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesManOption, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onFocus", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "订单号码", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.customerOrderNo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.customerOrderNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "开始日期", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "label" }, "到", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.listQuery.invoiceStatus,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.invoiceStatus) = $event)),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "0" }, {
                      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                        _createTextVNode("未收票", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "2" }, {
                      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                        _createTextVNode("部分收票", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "3" }, {
                      default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                        _createTextVNode("已收票", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "" }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode("全部", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleCommand('batch-dengji')))
          }, {
            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
              _createTextVNode(" 批量登记 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_DJ` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[35] || (_cache[35] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[36] || (_cache[36] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))]),
          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "ml-10 filter-mark" }, [
            _createElementVNode("span", { class: "status-item" }, [
              _createElementVNode("span", {
                class: "status-square",
                style: {"background-color":"red"}
              }),
              _createElementVNode("span", { class: "status-text" }, "需要收票")
            ])
          ], -1))
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
        ref: "tableDataRef",
        dataList: _ctx.list,
        total: _ctx.total,
        columnAllData: _ctx.columnAllData,
        tableName: _ctx.TableName,
        permissionName: _ctx.permissionName,
        tableRowClassName: _ctx.tableRowClassName,
        handleDefaultWidth: 120,
        showSelection: true,
        showSummary: true,
        onCommandChange: _ctx.handleCommand
      }, {
        "operation-action": _withCtx((scope) => [
          (scope.row.no == null && scope.row.status !== '已退款')
            ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                key: 0,
                href: "javascript:void(0);",
                class: "mr-10",
                type: "primary",
                onClick: ($event: any) => (_ctx.handleCommand('dengji', scope.row))
              }, {
                default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                  _createTextVNode(" 登记 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_DJ` }]
              ])
            : _createCommentVNode("", true),
          (scope.row.no)
            ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                key: 1,
                href: "javascript:void(0);",
                class: "mr-10",
                type: "primary",
                onClick: ($event: any) => (_ctx.handleCommand('cancel-ticket', scope.row))
              }, {
                default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                  _createTextVNode(" 作废 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_CANCEL_TICKET` }]
              ])
            : _createCommentVNode("", true),
          (scope.row.no)
            ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                key: 2,
                href: "javascript:void(0);",
                type: "warning",
                onClick: ($event: any) => (_ctx.handleCommand('return-ticket', scope.row))
              }, {
                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                  _createTextVNode(" 退票 ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, { pkey: `${_ctx.permissionName}_CANCEL_TICKET` }]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataList", "total", "columnAllData", "tableName", "permissionName", "tableRowClassName", "onCommandChange"])), [
        [_directive_loading, _ctx.listLoading]
      ])
    ], 512), [
      [_vShow, !_ctx.dengjiVisible]
    ]),
    (_ctx.dengjiVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.dengjiVisible,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dengjiVisible) = $event)),
          width: "80%",
          title: "登记发票"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_el_button, {
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dengjiVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleDJ
              }, {
                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "form-title mb-10" }, [
              _createElementVNode("span", { class: "label blue" }, "业"),
              _createElementVNode("span", { class: "left" }, "业务信息")
            ], -1)),
            _createVNode(_component_MiniBusinessList, { businessList: _ctx.selectionRowList }, {
              before: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "businessNo",
                  label: "业务编号",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "fee",
                  label: "总费用",
                  "show-overflow-tooltip": "",
                  width: "100",
                  align: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.$currency(row.fee)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "rate",
                  label: "税率",
                  "show-overflow-tooltip": "",
                  width: "60"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.rate) + "% ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "invoiceStatus",
                  label: "开票状态",
                  "show-overflow-tooltip": "",
                  width: "90"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "outsourceCompany",
                  label: "外包公司",
                  "show-overflow-tooltip": "",
                  width: "100"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "accountAlias",
                  label: "账户信息",
                  "show-overflow-tooltip": "",
                  width: "100"
                })
              ]),
              after: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "amount",
                  label: "数量",
                  width: "80"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "businessName",
                  label: "业务名称",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "businessBrand",
                  label: "业务品牌",
                  width: "100",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "businessModel",
                  label: "型号",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "businessUnit",
                  label: "单位"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "businessSerial",
                  label: "序列号",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  prop: "outCost",
                  label: "外包费成本",
                  width: "120",
                  align: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.$currency(row.business.outCost)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["businessList"]),
            _cache[44] || (_cache[44] = _createElementVNode("div", { class: "form-title mt-30 mb-10" }, [
              _createElementVNode("span", { class: "label green" }, "登"),
              _createElementVNode("span", { class: "left" }, "登记发票")
            ], -1)),
            _createVNode(_component_el_form, {
              ref: "dataForm",
              model: _ctx.ruleForm,
              rules: _ctx.rules,
              "label-position": "top",
              "label-width": "100px",
              class: "mb-20"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "扫码抢",
                  prop: "invoiceNumber"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.invoiceNumber,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.ruleForm.invoiceNumber) = $event)),
                      type: "textarea",
                      class: "filter-item",
                      onKeyup: _withKeys(_ctx.handleBarCodeChange, ["enter"]),
                      style: {"width":"700px"}
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_el_form_item, {
                    label: "发票号码",
                    prop: "no"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.no,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ruleForm.no) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "发票代码",
                    prop: "code"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.code,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ruleForm.code) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "发票校验码",
                    prop: "checkCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.checkCode,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.ruleForm.checkCode) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "发票金额",
                    prop: "amount"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.amount,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.ruleForm.amount) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "开票日期",
                    prop: "date"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.ruleForm.date,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.ruleForm.date) = $event)),
                        type: "date",
                        placeholder: " ",
                        format: "YYYY-MM-DD",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.returnVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.returnVisible,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.returnVisible) = $event)),
          title: "外包发票退票",
          width: "420px"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.returnVisible = false))
            }, {
              default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                _createTextVNode("取消", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.submitReturnTicket
            }, {
              default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                _createTextVNode("确定", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: _ctx.returnForm,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "发票信息" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createTextVNode("发票号码：" + _toDisplayString(_ctx.activeRow.no) + " ｜ 原发票金额：¥" + _toDisplayString(_ctx.activeRow.amount), 1),
                      (Number(_ctx.activeRow.returnAmount || 0) > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, " ｜ 已退金额：¥" + _toDisplayString(_ctx.activeRow.returnAmount), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "本次退票金额（全额退票将释放该发票关联）" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.returnForm.amount,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.returnForm.amount) = $event)),
                      min: 0.01,
                      max: Number((Number(_ctx.activeRow.amount || 0) - Number(_ctx.activeRow.returnAmount || 0)).toFixed(2)),
                      precision: 2,
                      "controls-position": "right",
                      style: {"width":"100%"}
                    }, null, 8, ["modelValue", "max"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}